/* import __COLOCATED_TEMPLATE__ from './client-app-landing.hbs'; */
import Component from '@glimmer/component';
import styles from './client-app-landing.module.scss';

export default class ClientAppBannerClientAppLanding extends Component {
  styles = styles;
}
